var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"board__icon",domProps:{"innerHTML":_vm._s(_vm.handleGetIcon(_vm.type))}},'span',attrs,false),on))]}}])},[_vm._v(" "+_vm._s(_vm.$t(("type." + _vm.type)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }